export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13856.4d8ab185.jpg";